import React from "react";
import { cn } from "@/lib/utils";
import { plural } from "@/lib/format";

// Status texts (not chips): colour carries the meaning. Red = late / rule broken · Amber = sanctioned · Default = needs you now · Grey = info
const base = "font-ui text-ui-xs whitespace-nowrap";

export function OverdueText({ days, className }) {
  return <span data-testid="overdue-text" className={cn(base, "text-destructive font-medium", className)}>Overdue {days != null ? `${days}d` : ""}</span>;
}
export function StuckBadge({ days, overdue8d = false, className }) {
  return <span data-testid="stuck-badge" className={cn(base, "text-destructive font-medium", className)}>{overdue8d ? "8D overdue" : `Stuck ${days}d`}</span>;
}
export function ExtendedText({ to, reason, className }) {
  return <span data-testid="extended-text" className={cn(base, "text-warning", className)}>Extended to {to}{reason ? ` · ${reason}` : ""}</span>;
}
export function WaitingText({ since, className }) {
  return <span data-testid="waiting-text" className={cn(base, "text-foreground", className)}>Customer waiting{since ? ` · ${since}` : ""}</span>;
}
export function QuietText({ days, className }) {
  return <span data-testid="quiet-text" className={cn(base, "text-warning", className)}>Gone quiet {days}d</span>;
}
export function NoFollowUpText({ className }) {
  return <span data-testid="nofollowup-text" className={cn(base, "text-destructive font-medium", className)}>No follow-up</span>;
}
export function InfoText({ children, className }) {
  return <span className={cn(base, "text-muted-foreground", className)}>{children}</span>;
}
export function DaysInStage({ days }) {
  return <InfoText>{plural(days ?? 0, "day")} in stage</InfoText>;
}
